import { UxUiComponent } from './modules/landing/services/ux-ui/ux-ui.component';
import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavigationComponent } from './shared/layout/navigation/navigation.component';
import { FooterComponent } from './shared/layout/footer/footer.component';
import { HomeComponent } from './modules/landing/home/home.component';
import { ServicesComponent } from './modules/landing/services/services.component';
import { OnboardingComponent } from './modules/landing/onboarding/onboarding.component';
import { ProyectsComponent } from './modules/landing/proyects/proyects.component';
import { ContactComponent } from './modules/landing/contact/contact.component';
import { JobsComponent } from './modules/landing/jobs/jobs.component';
import { WhoWeAreComponent } from './modules/landing/who-we-are/who-we-are.component';
import { MaintenanceComponent } from './modules/landing/services/maintenance/maintenance.component';
import { BusinessDevelopmentComponent } from './modules/landing/services/business-development/business-development.component';
import { DigitalMarketingComponent } from './modules/landing/services/digital-marketing/digital-marketing.component';
import { InfrastructureComponent } from './modules/landing/services/infrastructure/infrastructure.component';
import { TechnologyConsultingComponent } from './modules/landing/services/technology-consulting/technology-consulting.component';
import { AiConsultingComponent } from './modules/landing/services/ai-consulting/ai-consulting.component';
import { ConsultingProyectComponent } from './modules/landing/proyects/consulting-proyect/consulting-proyect.component';
import { DigitalGrowthProjectComponent } from './modules/landing/proyects/digital-growth-project/digital-growth-project.component';
import { DigitalExperienceProjectComponent } from './modules/landing/proyects/digital-experience-project/digital-experience-project.component';
import { TermsComponent } from './modules/landing/legal-advice/terms/terms.component';
import { PrivacyComponent } from './modules/landing/legal-advice/privacy/privacy.component';
import { CookiesComponent } from './modules/landing/legal-advice/cookies/cookies.component';
import { LegalAdviceComponent } from './modules/landing/legal-advice/legal-advice.component';
import { GoogleAnalyticsService } from './core/services/analytics/google-analytics.service';
import { DigitalKitComponent } from './modules/landing/digital-kit/digital-kit.component';
import { InfoCardComponent } from './shared/components/info-card/info-card.component';
import { InfoDropDownComponent } from './shared/components/info-drop-down/info-drop-down.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContactFormComponent } from './shared/components/contact-form/contact-form.component';
import { JobsFormComponent } from './shared/components/jobs-form/jobs-form.component';
import { NgOptimizedImage } from '@angular/common';



@NgModule({
  declarations: [
    AppComponent,
    NavigationComponent,
    FooterComponent,
    HomeComponent,
    ServicesComponent,
    OnboardingComponent,
    ProyectsComponent,
    ContactComponent,
    JobsComponent,
    WhoWeAreComponent,
    MaintenanceComponent,
    BusinessDevelopmentComponent,
    DigitalMarketingComponent,
    InfrastructureComponent,
    TechnologyConsultingComponent,
    UxUiComponent,
    AiConsultingComponent,
    ConsultingProyectComponent,
    DigitalGrowthProjectComponent,
    DigitalExperienceProjectComponent,
    LegalAdviceComponent,
    TermsComponent,
    PrivacyComponent,
    CookiesComponent,
    DigitalKitComponent,
    InfoCardComponent,
    InfoDropDownComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    ContactFormComponent,
    JobsFormComponent,
    NgOptimizedImage
],
  providers: [
    GoogleAnalyticsService,
    Title
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
